<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import BaseForm from './base-form';

export default {
    mixins: [BaseForm],
    props: [
        'openModal',
        'closeModal',
        'isModalOpen',
        'communityId',
    ],
    data: function() {
        return {
	        hears: [],
	    	rentOwn: [],
	    	sellPresentHome: [],
	    	purchaseTimes: [],
	    	reasons: [],
	        communities: [],

			fields: {
				hears: []
			},

            persistents: {
                selected_communities: [
                    this.communityId
                ],
                source_type_id: 7231176
            }
        }
    },
    created() {
    	this.getAnswers();
    },
    mounted() {
        this.boot();
    },
    methods: {
        getAnswers() {
        	this.showForm = false;
        	this.hears = ['Signs', 'Direct Mail', 'Referral', 'Internet', 'New Homes Map Guide', 'Broker/Realtor', 'Newspaper', 'Other'];
        	this.rentOwn = ['Rent', 'Own'];
        	this.sellPresent = ['Yes', 'No'];
        	this.purchaseTimes = ['Less than 1 month', '1-3 months', '3-6 months', 'Over 6 months'];
        	this.reasons = ['Tired of renting', 'Need larger home', 'Transfer', 'Other'];
        	this.showForm = true;
        },
        submit(event) {
            this.beforeSubmit();
            this.recaptchaSubmit().then(() => {
                this.form
                .post(event.target.action, {
                    ...this.fields, ...this.persistents
                })
                .then((result) => {
					setTimeout(() => {
						location.reload();
					}, 7500);

					this.success(result, event)
				})
                .catch((err) => this.failure());
            });
            
        }
    }
};
</script>
